import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { UsageStatsTextsTableRow } from "./TableRow";

import { RecordsTable } from "dyl-components";
import { useSearchParams, useNavigate } from "react-router-dom";
import UsageStatsTextsTableHeader from "./TableHeader";

const UsageStatsTextsTable = () => {
    const [params] = useSearchParams();
    const [filters, setFilters] = useState({
        contact_phone: params.get('contact_phone')?.split(','),
        customer_phone: params.get('customer_phone')?.split(','),
        user_id: params.get('user_id')?.split(',')
    })
    const {logs:texts, isReadingLogs, count = 0, isReadingTextUsers} = useSelector(state => state.text);
    const onFilter = async (_, { name, value }) => {
        setFilters({
            ...filters,
            [name]: value
        });
    }
    const navigate = useNavigate();
    const onPageChange = (_, { activePage }) => {
        const query = new URLSearchParams(params);
        query.set('page', activePage);
        const query_string = query.toString();
        navigate(`/settings/usage-stats/texts${query_string ? `?${query_string}` : ''}`);
    }

    useEffect(() => {
        const query = new URLSearchParams(params);

        const { contact_phone, customer_phone, user_id } = filters;

        if (contact_phone?.length > 0) {
            query.set('contact_phone', contact_phone);
            query.set('page', 1);
        } else {
            query.delete('contact_phone');
        }
        if (customer_phone?.length > 0) {
            query.set('customer_phone', customer_phone);
            query.set('page', 1);
        } else {
            query.delete('customer_phone');
        }
        if (user_id?.length > 0) {
            query.set('user_id', user_id);
            query.set('page', 1);
        } else {
            query.delete('user_id');
        }


        const { filter } = filters;
        if (filter?.length > 0) {
            query.set('filter', filter);
            query.set('page', 1);
        } else {
            query.delete('filter');
        }

        const query_string = query.toString();
        navigate(`/settings/usage-stats/texts${query_string ? `?${query_string}` : ''}`,);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])
    return (
        <RecordsTable
            tableBodyClassName='ModulesListTable'
            isTableLoading={isReadingLogs || isReadingTextUsers}
            isSearchResultEmpty={count === 0 && (params.get('search') || params.get('start') || params.get('end') || params.get('account_type') || params.get('owned_by'))}
            isTableEmpty={count === 0 && !(params.get('search') || params.get('start') || params.get('end') || params.get('account_type') || params.get('owned_by'))}
            TableHeader={<UsageStatsTextsTableHeader onFilter={onFilter} />}
            TableRows={texts?.map((text, index) => <UsageStatsTextsTableRow key={index} text={text} />)}
            recordsCount={count}
            activePage={params.get('page')}
            onPageChange={onPageChange}
            recordsName='Text'
            tableEmptyMessage={"No Texts Sent"}
            recordsLimit={25}
        />
    );
};

export default UsageStatsTextsTable;
